import React from "react";
import ReportTableSectionRenderer from "../../../../../libraries/ReportGenerator";
import { airbrakeAFMS92DaysSchema } from "./AirBrakeAFM92Schema";
import { getSupportingDocuments, titleOfReport } from "./CommonFunctions";

function AirBrakeAFM92Days(props) {
  const { singleReport } = props;
  return (
    <div>
      <span className="spacer"></span>
      <div style={{ textAlign: "center" }}>
        <h2 style={{ fontWeight: "bolder" }}>{titleOfReport(singleReport.testCode) || singleReport.title}</h2>
      </div>
      <table className="table-bordered">
        <ReportTableSectionRenderer section={airbrakeAFMS92DaysSchema} rowsData={singleReport.summary} />
      </table>
      {Object.keys(singleReport.summary).includes("supportingDocuments") && getSupportingDocuments(singleReport.summary)}
    </div>
  );
}

export default AirBrakeAFM92Days;



// WEBPACK FOOTER //
// ./src/components/Reports/ReVAMP/AirBrakeReports/AirBrakeReports/AirBrakeAFM92Days.jsx